import React, { useEffect, useState } from "react";
import CustomInput from "../CustomInput";
import Select from "../Select";
import { createLabMeasurement, getAmbients } from "../../services/labRegister";
import { useParams } from "react-router-dom";
import { TbClockExclamation } from "react-icons/tb";
import { socket } from "../../App";
import Notification from "../ui-elements/Notification";

const turnEquivalents = {
  Madrugada: "EarlyMorning",
  Mañana: "Morning",
  Tarde: "Afternoon",
  Noche: "Night",
};

const propertyEquivalents = {
  Temperatura: "temperature",
  Humedad: "humidity",
  Luz: "light",
  Ph: "ph",
};

const CustomModal = ({ title, img, handleCloseModal, isLateReg }) => {
  const params = useParams();
  const [valor, setValor] = useState(""); //valor de la propiedad
  const [options, setOptions] = useState(null); //opciones del select de ambiente
  const [ambient, setAmbient] = useState(null); //id de ambiente elegido
  //en este caso se usa el id porque es un valor con una relacion a la tabla de registros de laboratorios. para relaciones hay que usar el id
  const [obs, setObs] = useState(""); //observaciones
  const [sending, setSending] = useState(false);

  //================CARGA DE AMBIENTES=======================
  //traigo los ambientes que estan disponibles para mostrarlos en el select
  useEffect(() => {
    const fetchAmbients = async () => {
      try {
        //obtener lista de ambientes
        const { docs } = await getAmbients();

        //renombrar atributos (IMPORTANTE)
        //el componente customselect es generico, por lo que de acuerdo a las propiedades del objeto que se trae del back, hay que renonmbrar sus atributos para que puedan ser procesads dentro del componente select.
        //aqui se cambia name:"Ambiente 1" || "Ambiente 2" || ..., por text, y id:1adf3... || 13fas2... || ..., por value
        if (!docs || docs.length == 0) {
          Notification({
            title: "Operación inválida",
            text: `No hay ambientes registrados`,
            type: "Error",
          });
          handleCloseModal();
          return;
        }
        const temp = docs.map(({ name, id, ...rest }) => ({
          text: name,
          value: id,
          ...rest,
        }));
        //
        setOptions(temp);
      } catch (err) {
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    fetchAmbients();
    //console.log(params["*"]);
  }, []);

  //================handlers=======================

  const changeValor = (e) => {
    const nv = e.target.value;
    setValor(nv);
  };

  const changeAmbientValue = (e) => {
    setAmbient(e.target.value);
  };

  const changeObs = (e) => {
    const nv = e.target.value;
    setObs(nv);
  };

  const sendAlert = (message, data) => {
    socket.emit("LabMeasurementAlert", { message: message, data: data });
  };

  //===================envio de data====================

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setSending(true);

      //validar inputs
      if (valor == "" || !ambient) {
        //alert("Ingrese un valor numerico y seleccione el ambiente!");
        Notification({
          title: "Operación no válida",
          text: "Ingrese un valor numerico y seleccione el ambiente",
          type: "Error",
        });
        setSending(false);
      } else {
        //definir informacion a subir
        const props = {
          turn: turnEquivalents[params["*"]],
          dateAndTime: new Date(Date.now()),
          ambient: ambient,
          property: propertyEquivalents[title],
          value: parseFloat(valor), //enviar siempre como flotante
        };
        if (obs != "") props.observations = obs;
        if (isLateReg) props.wasLate = true;

        //enviar data
        const { status, data } = await createLabMeasurement(props);
        if (status == 201) {
          //send data to socket
          const createdData = data.doc;
          socket.emit("createdLabMeasurement", { data: data.doc });
          handleCloseModal();
          Notification({
            title: "Operación completada",
            text: `Se registró el valor${
              isLateReg ? " (fuera de horario)" : ""
            }`,
            type: "Success",
          });

          //envio de alerta
          switch (title) {
            case "Temperatura":
              if (createdData.value < 18.0 || createdData.value > 28.0) {
                const message =
                  createdData.value < 18.0
                    ? "Temperatura muy baja"
                    : "Temperatura muy alta";
                sendAlert(message, createdData);
              }
              break;
            case "Humedad":
              if (createdData.value < 60.0 || createdData.value > 80.0) {
                const message =
                  createdData.value < 60.0
                    ? "Humedad muy baja"
                    : "Humedad muy alta";
                sendAlert(message, createdData);
              }
              break;
            case "Ph":
              if (createdData.value < 5.8 || createdData.value > 6.5) {
                const message =
                  createdData.value < 5.8
                    ? "Nivel bajo de Ph(Alta acidez)"
                    : "Nivel alto de Ph(Alta alcalinidad)";
                sendAlert(message, createdData);
              }
              break;
            case "Luz":
              if (createdData.value > 20000.0 || createdData.value < 1000.0) {
                const message =
                  createdData.value < 1000.0
                    ? "Luminosidad muy baja"
                    : "Luminosidad muy alta";
                sendAlert(message, createdData);
              }
              break;
          }
        } else {
          setSending(false);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          throw new Error("Algó salió mal...");
        }
      }
    } catch (err) {
      setSending(false);
      console.error(err);
    }
  };
  if (!options) return <div>Loading...</div>;
  else
    return (
      <>
        <div className="w-full pl-4 pr-4 pb-2 flex flex-wrap h-full items-center gap-x-6">
          <div className="w-fit flex flex-row items-center">
            <div className="w-fit flex items-center ">
              <img src={img} className="w-[55px] " />
            </div>
            <div className="flex pl-2">
              <h1 className="text-black font-poppins text-2xl font-bold ">
                {title}
              </h1>
            </div>
          </div>
          <Select
            placeholder="Ambiente"
            options={options}
            value={ambient}
            setValue={changeAmbientValue}
            //customW="w-[140px]"
          />
        </div>
        <form className=" flex p-1 flex-col w-full items-center">
          <CustomInput
            title={"Valor registrado"}
            value={valor}
            onChange={changeValor}
            placeholder={`${
              title == "Temperatura"
                ? "Grados Celsius °C"
                : title == "Humedad"
                ? "% riego/agua"
                : title == "Luz"
                ? "Lúmenes"
                : "Acidez/Alcalinidad"
            }`}
            inputType="number"
            required={true}
          />
          <CustomInput
            title={"Observaciones (opcional)"}
            value={obs}
            onChange={changeObs}
            placeholder="Cómo alimentar a tu planta"
            type="text"
            required={false}
          />
          <button
            type="submit"
            onClick={handleSubmit}
            className={`${
              sending
                ? "bg-default-gray cursor-not-allowed"
                : "bg-dark-green hover:bg-accent-green"
            } 
             w-fit  text-xl flex flex-row rounded-full py-4 px-8 text-white  transition-all duration-100 font-bold font-poppins
            `}
          >
            {sending ? "Guardando..." : "Guardar"}
            {isLateReg && (
              <TbClockExclamation className="w-[25px] h-[25px] ml-2" />
            )}
          </button>
        </form>
      </>
    );
};

export default CustomModal;
